export default function Nav({ onBookDemo }) {
  return (
    <nav
      className="border-b border-linen bg-parchment/95 sticky top-0 z-30"
      data-testid="site-nav"
    >
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-brand">
          <svg className="w-6 h-6 text-[#2C2825]" viewBox="0 0 32 32" fill="none" aria-hidden="true">
            <circle cx="16" cy="16" r="13" stroke="currentColor" strokeWidth="1.8" />
            <path d="M10 16h12M16 10v12" stroke="currentColor" strokeWidth="1.8" />
          </svg>
          <span className="font-display text-2xl font-bold tracking-tight text-ink">
            SureLoom
          </span>
        </a>
        <div className="flex items-center gap-4 md:gap-8">
          <a
            href="#fabric"
            className="hidden md:inline text-sm font-body font-medium hover:text-clay transition-colors"
            data-testid="nav-protocol-link"
          >
            The Protocol
          </a>
          <a
            href="#compliance"
            className="hidden md:inline text-sm font-body font-medium hover:text-clay transition-colors"
            data-testid="nav-governance-link"
          >
            Governance
          </a>
          <button
            type="button"
            onClick={onBookDemo}
            className="text-xs font-mono uppercase tracking-wider px-4 py-2 border border-ink hover:bg-ink hover:text-white transition-colors"
            data-testid="nav-book-demo-btn"
          >
            Book Demo
          </button>
        </div>
      </div>
    </nav>
  );
}
